import { Component, OnInit, ViewChild, Inject, Optional } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ResendVerificationDialogComponent } from './resend-verification-dialog/resend-verification-dialog.component';
import { AuthenticationService } from '../../authentication/authentication.service';
import * as CryptoJS from 'crypto-js';

@Component({
  selector: 'app-verify-email',
  templateUrl: './verify-email.component.html',
  styleUrls: ['./verify-email.component.css']
})
export class VerifyEmailComponent implements OnInit {
  // @ViewChild('stepper', { static: true }) stepper!: MatStepper;
  // sipDetailsForm: FormGroup;
  // sipDetailsRequired: string = 'no';

  // firstFormGroup: FormGroup;
  // userDetailsForm: FormGroup;
  businessFormGroup: FormGroup;
  business = [];
  businessTypes = [];
  disposition = [];
  phoneScript = [];
  subscript = [];
  iduser: any;

  verificationCode: string;
  isVerificationCodePresent: boolean = false;
  // sipDetailsRequired: number = 0;  // COMMENTED OUT - NO ADDRESS FORM
  // selectedSipType: string;  // COMMENTED OUT - NO ADDRESS FORM
  media: any
  step_count: any;
  constructor(
    private _formBuilder: FormBuilder,
    private snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private dialog: MatDialog,
    private data: AuthenticationService,
    private router: Router,
    @Optional() @Inject(MAT_DIALOG_DATA) public dialogData: any,
    @Optional() public dialogRef: MatDialogRef<VerifyEmailComponent>
  ) { }

  ngOnInit() {

    this.data.get_business().subscribe((response: any) => {
      this.business = response.data;
    });

    // COMMENTED OUT - OTHER FORM GROUPS NOT NEEDED
    // this.firstFormGroup = this._formBuilder.group({
    //   verifyEmail: ['', Validators.required]
    // });

    // this.userDetailsForm = this._formBuilder.group({
    //   address1: ['', Validators.required],
    //   address2: [''],
    //   city: ['', Validators.required],
    //   state: ['', Validators.required],
    //   zipCode: ['', Validators.required],
    //   country: ['', Validators.required],
    //   sipName: [''],
    //   sipType: [''],
    //   supplierIp: [''],
    //   port: [''],
    //   prefix: [''],
    //   rate: [''],
    //   agentLimit: ['', [Validators.required, Validators.min(1)]]
    // });

    // ONLY BUSINESS FORM GROUP NEEDED
    this.businessFormGroup = this._formBuilder.group({
      businessOption: ['', Validators.required],
      businessType: ['', Validators.required],
      disposition: [[], Validators.required],
      phoneScript: [[], Validators.required],
      subscript: [[], Validators.required],
      websiteUrl: ['', [
        Validators.pattern(/^(https?:\/\/)?([\da-z\.-]+\.[a-z\.]{2,6}|[\d\.]+)([\/\w \.-]*)*\/?$/)
      ]]
    });

    // Get verification code from URL
    // this.route.queryParams.subscribe(params => {
    //   this.verificationCode = params['code'];
    //   this.isVerificationCodePresent = !!this.verificationCode;
    // });

  };
ngAfterViewInit(): void {
  //Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
  //Add 'implements AfterViewInit' to the class.
  
  // Check if opened as dialog with data
  if (this.dialogData && this.dialogData.encryptedData) {
    // Use dialog data
    this.processEncryptedData(this.dialogData.encryptedData);
  } else {
    // Use route parameters (for non-dialog usage)
    this.route.queryParams.subscribe(params => {
      if (params['data']) {
        this.processEncryptedData(params['data']);
      }
    });
  }
}

processEncryptedData(encryptedData: string): void {
  try {
    const decryptedData = CryptoJS.AES.decrypt(encryptedData, 'verify_email').toString(CryptoJS.enc.Utf8);
    console.log(decryptedData, 'decryptedData')
    const queryData = JSON.parse(decryptedData);
    this.verificationCode = queryData.code;
    this.media = queryData.media; // capture media from query params
    console.log(this.verificationCode,  this.media)
    this.step_count = queryData.step_count;
    console.log(this.step_count, 'step_count')
    this.iduser = queryData.id;
    console.log(this.iduser, 'iduser')
    
    // SKIP EMAIL VERIFICATION - GO DIRECTLY TO BUSINESS FORM
    this.isVerificationCodePresent = true;
    // No form setValue needed since we only have business form now
  } catch (error) {
    console.error('Error processing encrypted data:', error);
  }
}
  // COMMENTED OUT - EMAIL VERIFICATION METHOD
  /* 
  verifyEmail(stepper?: MatStepper,msg?:string) {
    this.data.verifyEmail(this.verificationCode).subscribe((response: any) => {
      console.log('Verification email:', response);
      if (response.status == 200) {
        console.log('Verification successful:', response);
        if(msg){
          this.snackbarwarn(msg, 'Close');
        }else{
          this.snackbarwarn(response.message, 'Close');
        }
        this.firstFormGroup.get('verifyEmail').setValue(response.id);
        this.iduser = response.id;
        if (stepper) {
          stepper.next();
        } else if (this.stepper) {
          this.stepper.next();
        }
      } else if (response.status == 400) {
        this.snackbarwarn(response.message, 'Close');
      } else {
        this.snackbarwarn('Something went wrong', 'Close');
      }
    });
  }
  */
  snackbarwarn(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 5000
      , verticalPosition: 'top',
      horizontalPosition: 'center',
      panelClass: ['snackbarwarn']
    });
  }
  // COMMENTED OUT - RESEND VERIFICATION DIALOG METHOD
  /*
  openResendDialog() {
    const dialogRef = this.dialog.open(ResendVerificationDialogComponent, {
      width: '400px'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // Here you would typically call your service to resend verification email
        this.data.resendVerificationEmail(result).subscribe((response: any) => {
          console.log('Resend verification email:', response);
          if (response.status == 200) {
            this.snackbarwarn('Verification email has been sent', 'Close');
          } else if (response.status == 400) {
            this.snackbarwarn(response.message, 'Close');
          } else {
            this.snackbarwarn('Failed to resend verification email', 'Close');
          }
        });
      }
    });
  }
  */

  completeRegistration() {
    // Here you would typically save the business type and complete registration
    console.log('Form valid:', this.businessFormGroup.valid);
    console.log('Form errors:', this.businessFormGroup.errors);
    console.log('Registration completed with business type:', this.businessFormGroup.value);
    console.log('User ID:', this.iduser);
    
    // Ensure iduser is set
    this.businessFormGroup.value.iduser = this.iduser;
    
    // Fix data structure to match backend expectations
    let data = { 
      secondFormGroup: this.businessFormGroup.value,  // Backend expects secondFormGroup
      userDetailsForm: {}  // Send empty object since we removed address form
    }
    console.log('Sending data to backend:', JSON.stringify(data, null, 2));
    this.data.ai_setup_save(data).subscribe(
      (response: any) => {
        console.log('AI setup response:', response);
        if (response.status == 200) {
          this.snackbarwarn(response.message, 'Close');
          
          // If opened as dialog, close it with success result
          if (this.dialogRef) {
            this.dialogRef.close({ success: true, data: response });
          } else {
            // If not dialog, navigate to login
            this.router.navigate(['/login']);
          }
        } else {
          this.snackbarwarn('Something went wrong', 'Close');
        }
      },
      (error: any) => {
        console.error('AI setup error:', error);
        this.snackbarwarn('Network error occurred', 'Close');
      }
    );
  }

  // Close dialog method
  closeDialog(result?: any) {
    if (this.dialogRef) {
      this.dialogRef.close(result);
    }
  }

  // COMMENTED OUT - NO USER DETAILS FORM NEEDED
  // saveUserDetails(stepper: MatStepper) {
  //   if (this.userDetailsForm.valid) {
  //     // Here you would typically save the user details
  //     console.log('User details:', this.userDetailsForm.value);
  //     stepper.next();
  //   } else {
  //     this.snackbarwarn('Please fill in all required fields', 'Close');
  //   }
  // }

  onBusinessTypeChange(event: any) {
    console.log('Business type changed:', event.value);
    this.fordispositions(this.business[0].name, event.value);
    this.forphoneScript(this.business[0].name, event.value);
    this.forSubscript(this.business[0].name, event.value);

  }
  fordispositions(business: any, businessType: any) {
    let prompt = `Provide a JSON object for sample dispositions used in business ${business} of ${businessType}. Each disposition should be an object with two properties: "Disposition Label" and "Abbreviation". Return an array under the key "dispositions" and return only the JSON.`
    this.data.ai_setup(prompt).subscribe((response: any) => {
      if (response.status == 200) {
        try {
          // First parse the outer response
          const outerResponse = JSON.parse(response.response);
          // Then parse the actual JSON content, removing the markdown code block markers
          const jsonContent = outerResponse.response.replace(/```json\n|\n```/g, '');
          const data = JSON.parse(jsonContent);
          this.disposition = data.dispositions;
          // Set initial dispositions based on business type
          if (this.disposition && this.disposition.length > 0) {
            this.businessFormGroup.get('disposition').setValue(this.disposition);
          }
          console.log('Parsed dispositions:', this.disposition);
        } catch (error) {
          console.error('Error parsing dispositions:', error);
        }
      }
    });
  }
  forphoneScript(business: any, businessType: any) {
    let prompt = `Provide a JSON object for sample phone scripts used in business ${business} of ${businessType}. Each script should be an object with two properties: "Script Name" and "Script Content". Return an array under the key "scripts" and return only the JSON..`
    this.data.ai_setup(prompt).subscribe((response: any) => {
      if (response.status == 200) {
        try {
          const outerResponse = JSON.parse(response.response);
          const jsonContent = outerResponse.response.replace(/```json\n|\n```/g, '');
          const data = JSON.parse(jsonContent);
          this.phoneScript = data.scripts;
          console.log('Parsed phone scripts:', this.phoneScript);
          if (this.phoneScript && this.phoneScript.length > 0) {
            this.businessFormGroup.get('phoneScript').setValue(this.phoneScript);
          }
        } catch (error) {
          console.error('Error parsing phone scripts:', error);
        }
      }
    });
  }
  forSubscript(business: any, businessType: any) {
    let prompt = `Provide a JSON object for sample objection scripts used in business ${business} of ${businessType}. Each objection script should be an object with two properties: "Objection Script Name" and "Objection Script Content". Return an array under the key "objection_scripts" and return only the JSON.`
    this.data.ai_setup(prompt).subscribe((response: any) => {
      if (response.status == 200) {
        try {
          const outerResponse = JSON.parse(response.response);
          const jsonContent = outerResponse.response.replace(/```json\n|\n```/g, '');
          const data = JSON.parse(jsonContent);
          this.subscript = data.objection_scripts;
          console.log('Parsed objection scripts:', this.subscript);
          if (this.subscript && this.subscript.length > 0) {
            this.businessFormGroup.get('subscript').setValue(this.subscript);
          }
        } catch (error) {
          console.error('Error parsing objection scripts:', error);
        }
      }
    });
  }
  getbuinesstype(business: any) {
    this.data.get_business_type(business).subscribe((response: any) => {
      this.businessTypes = response.data;
    });
    this.disposition = [];
    this.phoneScript = [];
    this.subscript = [];
    this.businessFormGroup.get('disposition').setValue(this.disposition);
    this.businessFormGroup.get('phoneScript').setValue(this.phoneScript);
    this.businessFormGroup.get('subscript').setValue(this.subscript);
  }
  // COMMENTED OUT - NO SIP DETAILS NEEDED
  // addSipDetails(value: any) {
  //   if (value == 1) {
  //     this.sipDetailsRequired = 1;
  //     this.userDetailsForm.get('sipName').setValidators([Validators.required]);
  //     this.userDetailsForm.get('sipType').setValidators([Validators.required]);
  //     this.userDetailsForm.get('supplierIp').setValidators([Validators.required]);
  //     this.userDetailsForm.get('port').setValidators([Validators.required]);
  //     this.userDetailsForm.get('prefix').setValidators([Validators.required]);
  //     this.userDetailsForm.get('rate').setValidators([Validators.required]);
  //   } else {
  //     this.sipDetailsRequired = 0;
  //     this.userDetailsForm.get('sipName').clearValidators();
  //     this.userDetailsForm.get('sipType').clearValidators();
  //     this.userDetailsForm.get('supplierIp').clearValidators();
  //     this.userDetailsForm.get('port').clearValidators();
  //     this.userDetailsForm.get('prefix').clearValidators();
  //     this.userDetailsForm.get('rate').clearValidators();
  //   }
  //   this.userDetailsForm.get('sipName').updateValueAndValidity();
  //   this.userDetailsForm.get('sipType').updateValueAndValidity();
  //   this.userDetailsForm.get('supplierIp').updateValueAndValidity();
  //   this.userDetailsForm.get('port').updateValueAndValidity();
  //   this.userDetailsForm.get('prefix').updateValueAndValidity();
  //   this.userDetailsForm.get('rate').updateValueAndValidity();
  // }

  // onSipTypeChange(value: string) {
  //   this.selectedSipType = value;
  // }

}
// function ViewChild(arg0: string): (target: VerifyEmailComponent, propertyKey: "stepper") => void {
//   throw new Error('Function not implemented.');
// }

